import { TABLE_COLUMN_TYPE } from "../../../constants"
import { TableColumn, TrackPlaylist } from "../../../types"
import { KSpan, KTitleSpan, KTooltip } from "kahuna-base-react-components"
//@ts-ignore
import HeadphonesIcon from "../../../assets/admin_icons/headphones.svg"
//@ts-ignore
import SpotifyIcon from "../../../assets/release-platform-icons/SpotifyIcon.png"
//@ts-ignore
import AppleMusicIcon from "../../../assets/release-platform-icons/Apple-Music.png"
//@ts-ignore
import MoreIcon from "../../../assets/admin_icons/horizontal-dots.svg"
import { formatIsoDate, processAddedRemovedDates, removeAnchorTags } from "../../../utility"
import ImageWithFallback from "../../ui/components/ImageWithFallback"
import { lang } from "../../../constants/languages"
import TruncatedListWithTooltip from "./components/TruncatedListWithTooltip"
import React from "react"


const datePairComponent = (addedAtArray: string[], removedAtArray: string[], index: number) => {
  return (
    <div className="flex flex-row gap-1 items-center" key={`${addedAtArray[index]}-${index}`}>
      <div className="rounded-[4px] bg-[#F7F7F7] flex items-center justify-center p-1 w-max min-w-[76px] max-w-[200px]">
        <KSpan
          text={`${addedAtArray[index] !== "-" ? formatIsoDate(addedAtArray[index], true) : "-"}`}
          color="#111"
          fontSize={11}
          fontWeight={500}
          lineHeight="12px"
          letterSpacing="0.22px"
        />
      </div>
      <KSpan text={"-"} color="#111" fontSize={11} fontWeight={500} lineHeight="12px" letterSpacing="0.22px" />
      <div className="rounded-[4px] bg-[#F7F7F7] flex items-center justify-center p-1 w-max min-w-[76px]">
        <KSpan
          text={`${
            removedAtArray[index] !== "-" ? formatIsoDate(removedAtArray[index], true) : lang.playlists.still_in
          }`}
          color="#111"
          fontSize={11}
          fontWeight={500}
          lineHeight="12px"
          letterSpacing="0.22px"
        />
      </div>
    </div>
  )
}

const playlistsColumns: TableColumn[] = [
  {
    header: lang.playlists.playlist,
    headerStyle: {
      textAlign: "left",
      width: "35%"
    },
    overrideHeader: () => <KSpan text={lang.playlists.playlist} color="#111" fontWeight={500} fontSize={16} />,

    type: TABLE_COLUMN_TYPE.FUNCTION,
    render: (row: TrackPlaylist) => {
      const monthlyChange = row?.playlist?.fdiffMonth
      const weeklyChange = row?.playlist?.fdiffWeek
      const tags = row?.playlist?.tags.split(", ")
      const moods = row?.playlist?.moods
        .split(", ")
        .map((mood: string) => mood.charAt(0).toUpperCase() + mood.slice(1).toLowerCase())
        .sort((a, b) => a.length - b.length)
      const playlistId = row?.playlist?.playlistId
      let baseUrl = "https://open.spotify.com/playlist/"
    
      const iconSize = 22
      const platform = row?.playlist?.platform
      let icon = SpotifyIcon
      let storefrontList:string[] = []
      if (platform === "Apple") {
        icon = AppleMusicIcon

        const currentStorefronts = row?.currentStorefronts || ""
        const removedStorefronts = row?.removedStorefronts || ""
        const storefronts:string = currentStorefronts ? currentStorefronts : removedStorefronts
        storefrontList = storefronts.split(",").sort()
        let chosenStorefront = "us"
        if (storefrontList.includes("TR")) chosenStorefront = "tr"
        else if (storefrontList?.length > 0) chosenStorefront = storefrontList[0].toLowerCase()
        baseUrl = `https://music.apple.com/${chosenStorefront}/playlist/`
      }
      const defaultTargetUrl = `${baseUrl}${playlistId}`
      const targetUrlWithParam = `https://music.apple.com/<param>/playlist/${playlistId}`
        
      return (
        <div className="flex gap-2 whitespace-nowrap text-ellipsis ">
          <ImageWithFallback
            coverFileUrl={row?.playlist?.image || ""}
            overrideDefaultImage={HeadphonesIcon}
            overrideTargetUrl={defaultTargetUrl}
            width={125}
            height={125}
          />
          <div className="flex flex-col justify-between max-w-[calc(28vw-200px)] min-[1500px]:min-w-[310px] max-[1500px]:min-w-[200px]">
            <div className="flex flex-row items-center gap-3.5 w-full">
              <div
                style={{
                  maxWidth: `calc(100% - (${iconSize + 14}px)`,
                  paddingTop: "2px"
                }}
              >
                <KTitleSpan
                  text={row?.playlist?.name || "-"}
                  color="#000"
                  fontWeight={500}
                  fontSize={16}
                  lineHeight="18px"
                  ellipsis={true}
                />
              </div>
              <img
                className="cursor-pointer no-parent-trigger"
                src={icon}
                style={{ width: iconSize, height: iconSize, minWidth: iconSize, minHeight: iconSize }}
                onClick={() => window.open(defaultTargetUrl, "_blank")}
              />
            </div>
            {platform === "Spotify" && (
              <div className="flex flex-row gap-1 items-center">
                <div className="rounded-[4px] bg-[#F7F7F7] flex items-center p-1 gap-1 flex-wrap">
                  <KSpan
                    text={`${lang.playlists.saves}: ${row?.playlist?.followers}`}
                    color="#111"
                    fontSize={11}
                    fontWeight={500}
                    lineHeight="12px"
                    letterSpacing="0.22px"
                  />
                  <div className="flex flex-row items-center gap-1">
                    <KSpan text={"("} color="#999" fontSize={10} lineHeight="12px" fontWeight={500} />
                    <KSpan
                      text={`${monthlyChange > 0 ? "+" : ""}${monthlyChange}`}
                      color={monthlyChange > 0 ? "#56E099" : "#FF5865"}
                      fontSize={10}
                      lineHeight="12px"
                    />
                    <KSpan
                      text={`${lang.playlists.this_month}, `}
                      color="#999"
                      fontSize={10}
                      lineHeight="12px"
                      fontWeight={500}
                    />
                  </div>
                  <div className="flex flex-row items-center gap-1">
                    <KSpan
                      text={`${weeklyChange > 0 ? "+" : ""}${weeklyChange}`}
                      color={weeklyChange > 0 ? "#56E099" : "#FF5865"}
                      fontSize={10}
                      lineHeight="12px"
                    />
                    <KSpan
                      text={lang.playlists.this_week}
                      color="#999"
                      fontSize={10}
                      lineHeight="12px"
                      fontWeight={500}
                    />{" "}
                    <KSpan text={")"} color="#999" fontSize={10} lineHeight="12px" fontWeight={500} />
                  </div>
                </div>
              </div>
            )}
            {platform === "Apple" && (
              <TruncatedListWithTooltip
                itemList={storefrontList}
                visibleItemCount={6}
                breakPointInPx={1400}
                smallScreenVisibleItemCount={4}
                title={`${lang.playlists.storefronts_title}:`}
                separateByComma={true}
                navigateOnItemClick={true}
                targetUrl={targetUrlWithParam}
                hideDelay={300}
              />
            )}
            <TruncatedListWithTooltip
              itemList={tags}
              visibleItemCount={3}
              breakPointInPx={1400}
              smallScreenVisibleItemCount={2}
              title={`${lang.playlists.tags_title}:`}
            />
            <TruncatedListWithTooltip
              itemList={moods}
              visibleItemCount={3}
              smallScreenVisibleItemCount={2}
              title={`${lang.playlists.moods_title}:`}
            />
            <div className="rounded-[4px] bg-[#F7F7F7] p-1 w-min max-w-full">
              {row?.playlist?.description ? (
                <KTitleSpan
                  text={`${row?.playlist?.description ? removeAnchorTags(row?.playlist?.description) : "-"}`}
                  color="#111"
                  fontSize={11}
                  fontWeight={500}
                  lineHeight="12px"
                  letterSpacing="0.22px"
                  ellipsis={true}
                  tooltipProps={{
                    padding: "0px",
                    content: row?.playlist?.description ? (
                      <div className="w-max max-w-[350px] whitespace-normal pl-1.5 pr-1 py-[1px]">
                        <KSpan
                          text={`${row?.playlist?.description ? removeAnchorTags(row?.playlist?.description) : "-"}`}
                          color="#111"
                          fontSize={13}
                          lineHeight="16px"
                        />
                      </div>
                    ) : null
                  }}
                />
              ) : (
                  <div className=" flex flex-row items-center gap-1">
                    <KSpan
                      text={"Description:  -"}
                      color="#111"
                      fontSize={11}
                      fontWeight={500}
                      lineHeight="12px"
                      letterSpacing="0.22px"
                    />
                  </div>
                  
              )}
            </div>
          </div>
        </div>
      )
    }
  },
  {
    header: lang.playlists.track,
    headerStyle: {
      textAlign: "left",
      width: "35%",
      fontSize: "16px"
    },
    overrideHeader: () => <KSpan text={lang.playlists.track} color="#111" fontWeight={500} fontSize={16} />,
    type: TABLE_COLUMN_TYPE.FUNCTION,
    render: (row: TrackPlaylist) => {
      const artists = row?.track?.artistList.map((artist) => artist.name).sort((a, b) => a.length - b.length)
      return (
        <div className="flex gap-2 whitespace-nowrap max-w-full">
          <ImageWithFallback
            coverFileUrl={row?.track?.release?.coverFileUrl || ""}
            width={125}
            height={125}
            doNotAllowRouting={true}
          />
          <div className="flex flex-col justify-between">
            <div className="max-[1500px]:max-w-[170px] min-[1500px]:max-w-[350px] pt-0.5">
              <KTitleSpan
                text={row?.track?.title}
                color="#000"
                fontWeight={500}
                fontSize={16}
                lineHeight="16px"
                ellipsis={true}
              />
            </div>
            <div className="flex">
              <KTooltip
                backgroundColor="#000"
                position="bottom"
                content={
                  <div className="w-max flex flex-col gap-1 items-start">
                    <KSpan
                      text={`${lang.playlists.release_date}: ${formatIsoDate(row?.track?.release?.releaseDate, true)}`}
                      color="#FFF"
                      fontSize={11}
                      fontWeight={500}
                      lineHeight="16px"
                      letterSpacing="0.22px"
                    />
                  </div>
                }
                hideDelay={200}
              >
                <div className="rounded-[4px] bg-[#F7F7F7] flex items-center p-1 gap-1 flex-wrap">
                  <KSpan
                    text={`${lang.playlists.release}:`}
                    color="#111"
                    fontSize={11}
                    fontWeight={500}
                    lineHeight="12px"
                    letterSpacing="0.22px"
                  />
                  <KSpan
                    text={`${row?.track?.release?.title}`}
                    color="#111"
                    fontSize={11}
                    fontWeight={500}
                    lineHeight="12px"
                    letterSpacing="0.22px"
                  />
                </div>
              </KTooltip>
            </div>
            <TruncatedListWithTooltip
              itemList={artists}
              visibleItemCount={2}
              breakPointInPx={1400}
              smallScreenVisibleItemCount={1}
              title={`${lang.playlists.artist}:`}
            />
            <div className="rounded-[4px] bg-[#F7F7F7] flex items-center p-1 w-min">
              <KSpan
                text={`ISRC: ${row?.track?.isrc}`}
                color="#111"
                fontSize={11}
                fontWeight={500}
                lineHeight="12px"
                letterSpacing="0.22px"
              />
            </div>
            <div className="rounded-[4px] bg-[#F7F7F7] flex items-center p-1 w-min gap-1">
              <KTooltip
                backgroundColor="#000"
                arrowColor="#000"
                position="bottom"
                content={
                  <div className="w-max flex flex-col gap-1 items-start">
                    <KSpan
                      text={`${lang.playlists.position_explanation}`}
                      fontSize={12}
                      fontWeight={500}
                      lineHeight="16px"
                      color="#FFF"
                    />
                  </div>
                }
              >
                <div className="flex items-center gap-1">
                  <div className="flex max-[1400px]:!hidden">
                    <KSpan
                      text={`${lang.playlists.position}:`}
                      color="#111"
                      fontSize={11}
                      fontWeight={500}
                      lineHeight="12px"
                      letterSpacing="0.22px"
                    />
                  </div>
                  <div className="flex">
                    <KSpan
                      text={`${lang.playlists.current} ${row?.position || "-"}, ${lang.playlists.peak} ${
                        row?.peakPosition || "-"
                      }`}
                      color="#111"
                      fontSize={11}
                      fontWeight={500}
                      lineHeight="12px"
                      letterSpacing="0.22px"
                    />
                  </div>
                </div>
              </KTooltip>
            </div>
          </div>
        </div>
      )
    }
  },
  {
    header: `${lang.playlists.added_at} - ${lang.playlists.removed_at}`,
    headerStyle: {
      textAlign: "left",
      minWidth: "120px",
      width: "15%"
    },
    overrideHeader: () => (
      <KSpan
        text={`${lang.playlists.added_at} - ${lang.playlists.removed_at}`}
        color="#111"
        fontWeight={500}
        fontSize={14}
      />
    ),
    type: TABLE_COLUMN_TYPE.FUNCTION,
    render: (row: TrackPlaylist) => {

      const addedAtArray = row?.addedAt ? row?.addedAt?.split(", ") : ["-"]
      const removedAtArray = row?.removedAt ? row?.removedAt?.split(", ") : ["-"]
      const processedDates = processAddedRemovedDates(addedAtArray.reverse(), removedAtArray.reverse())
      const finalAddedAtArray = processedDates.finalAddedAtArray.reverse()
      const finalRemovedAtArray = processedDates.finalRemovedAtArray.reverse()
      return (
        <div>
          <div className="flex flex-row gap-2">
            <div
              className="flex flex-col gap-2"
              style={{
                gap: 8
              }}
            >
              {finalAddedAtArray.length < 4 ? (
                finalAddedAtArray.map((addedAt, index: number) => {
                  return datePairComponent(finalAddedAtArray, finalRemovedAtArray, index)
                })
              ) : (
                <React.Fragment>
                  {datePairComponent(finalAddedAtArray, finalRemovedAtArray, 0)}
                  <KTooltip
                    position="left"
                    content={
                      <div className="flex flex-col gap-2 items-center justify-center">
                        {finalAddedAtArray.slice(1, -1).map((addedAt, index: number) => {
                          return datePairComponent(finalAddedAtArray, finalRemovedAtArray, index + 1)
                        })}
                      </div>
                    }
                  >
                    <div className="flex items-center justify-center gap-2">
                      <img src={MoreIcon} />
                      <KSpan text={`+${(finalAddedAtArray.length - 2)} ${lang.common.more}`} color="#111" fontSize={12} fontWeight={500} />
                    </div>
                  </KTooltip> 

                  {datePairComponent(finalAddedAtArray, finalRemovedAtArray, finalAddedAtArray.length - 1)}
                </React.Fragment>
              )}
            </div>
          </div>
        </div>
      )
    }
  },
  {
    header: `${lang.playlists.updated}`,
    headerStyle: {
      textAlign: "left",
      minWidth: "120px",
      width: "15%"
    },
    overrideHeader: () => <KSpan text={`${lang.playlists.updated}`} color="#111" fontWeight={500} fontSize={14} />,
    type: TABLE_COLUMN_TYPE.FUNCTION,
    render: (row: TrackPlaylist) => {
      const updatedDate = row?.updated ?? ""
      const cmSysLastUpdatedDate = row?.cmSysLastUpdated
      const playlistLastUpdatedDate = row?.playlist?.playlistLastUpdated
      const playlistUpdate = playlistLastUpdatedDate ?? cmSysLastUpdatedDate
      const platform = row?.playlist?.platform

      return (
        <div>
          {platform === "Spotify" && (
            <div className="flex flex-col gap-1">
              <div className="rounded-[4px] bg-[#F7F7F7] flex items-center p-1 w-max">
                <KTooltip
                  backgroundColor="#000"
                  arrowColor="#000"
                  position="bottom"
                  align="left"
                  marginLeft="20px"
                  content={
                    <div className="w-[200px] flex flex-col gap-1 items-start">
                      <KSpan
                        text={lang.playlists.updated_tooltip_spotify}
                        fontSize={12}
                        fontWeight={500}
                        lineHeight="16px"
                        color="#FFF"
                      />
                    </div>
                  }
                >
                  <div className="flex">
                    <KSpan
                      text={`Spotify: ${formatIsoDate(playlistUpdate.slice(0, 10), true)}`}
                      color="#111"
                      fontSize={11}
                      fontWeight={500}
                      lineHeight="12px"
                      letterSpacing="0.22px"
                    />
                  </div>
                </KTooltip>
              </div>
              <div className="rounded-[4px] bg-[#F7F7F7] flex items-center p-1 w-max">
                <KTooltip
                  backgroundColor="#000"
                  arrowColor="#000"
                  position="bottom"
                  align="left"
                  marginLeft="20px"
                  content={
                    <div className="w-[200px] flex flex-col gap-1 items-start">
                      <KSpan
                        text={lang.playlists.updated_tooltip_kahuna}
                        fontSize={12}
                        fontWeight={500}
                        lineHeight="16px"
                        color="#FFF"
                      />
                    </div>
                  }
                >
                  <div className="flex">
                    <KSpan
                      text={`Kahuna: ${formatIsoDate(updatedDate?.slice(0, 10), true)}`}
                      color="#111"
                      fontSize={11}
                      fontWeight={500}
                      lineHeight="12px"
                      letterSpacing="0.22px"
                    />
                  </div>
                </KTooltip>
              </div>
            </div>
          )}
          {platform === "Apple" && (
            <div className="flex">
              <KSpan
                text={`${formatIsoDate(updatedDate?.slice(0, 10), true)}`}
                color="#111"
                fontSize={11}
                fontWeight={500}
                lineHeight="12px"
                letterSpacing="0.22px"
              />
            </div>
          )}
        </div>
      )
    }
  }
]

export default playlistsColumns